export const DOWNLOAD_INVENTORY_SAMPLE_URL = `https://storage.googleapis.com/kanda-ai-core/static/csv-example/upload-product-inventories-example.csv`;
